import(/* webpackMode: "eager" */ "/app/apps/ui/src/app/[locale]/error.tsx");
